import { render, staticRenderFns } from "./WorkerGroupEdit.vue?vue&type=template&id=68770369&scoped=true&"
import script from "./WorkerGroupEdit.vue?vue&type=script&lang=js&"
export * from "./WorkerGroupEdit.vue?vue&type=script&lang=js&"
import style0 from "./WorkerGroupEdit.vue?vue&type=style&index=0&id=68770369&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68770369",
  null
  
)

export default component.exports